import React, { useMemo, useEffect } from 'react';
import { OptionsType } from '../../utils/customSelectUtils';
import {
  arrayToSimpleObj,
  commonBackInfo,
  dealwithLanguage,
} from '../../utils';
import type { SingleCommonType } from '../../types';
import { Select } from 'tea-component';
import { languagePlaceholder } from '../../constants/placeholder';
import './index.scss';
import { addFilterBuriedPoint } from '../../utils/point';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function GPTLanguageSelect({
  onChange,
  languageChoose,
  setLanguageChoose,
  filterOptions,
  lang,
}: SingleCommonType & {
  languageChoose: string;
  setLanguageChoose: any;
}) {
  const languageOptions = useMemo(() => {
    let language: { [key: string]: any } = {};
    if (filterOptions) {
      language = filterOptions?.language || filterOptions;
    }
    return language;
  }, [filterOptions]);

  const options: OptionsType = useMemo(() => {
    return dealwithLanguage(languageOptions, '', lang);
  }, [languageOptions, lang]);

  const languageMap = arrayToSimpleObj(options);

  const languageButton = useMemo(() => {
    return (
      <div className="dbo-select-button">
        <span className="select-button-text">{languagePlaceholder[lang]}</span>
        {languageMap[languageChoose]}
      </div>
    );
  }, [lang, languageChoose, languageMap]);

  useEffect(() => {
    onChange?.(
      'language',
      commonBackInfo(
        { language: languageChoose },
        { language: languageButton },
      ),
    );
  }, [languageChoose]);

  return (
    <div className="dbo-gpt-language-select-wrapper">
      <Select
        className="select-item"
        size="m"
        matchButtonWidth
        appearance="button"
        value={languageChoose}
        onChange={(value) => {
          setLanguageChoose(value);
          addFilterBuriedPoint(FilterButtonPoint.language, value);
        }}
        options={options}
        button={languageButton}
      />
    </div>
  );
}
